@for (image of images; track image) {
  <img [src]="image" width="1" height="1" alt="" />
}
